module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGames/mlb/weekly-f3ea27cea975af7cd1c5e40a9174dc65.svg";